module.exports = __webpack_public_path__ + "static/cover-752b21b0f7dc40394db58cb34864519f.jpg";